import React from "react";

import "./App.css";

import Main from "./Main";

const App: React.FC = () => {
  return (
    <div className="App">
      <Main />
    </div>
  );
};

export default App;
